"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderDataForOrdersPage = void 0;
class OrderDataForOrdersPage {
}
exports.OrderDataForOrdersPage = OrderDataForOrdersPage;
//# sourceMappingURL=OrderDataForOrdersPage.js.map